import { Component, OnInit, forwardRef, Input, SimpleChanges, OnChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PersonDetailsConfig, PersonDetailsErrors, PersonDetails } from './person-details.model';
import { LookupData } from 'src/app/shared/models/lookup-data.model';
import { DateTime } from 'luxon';
import { slideInOut } from 'src/app/application/animations/slideInOut';
import { formatDate } from '@angular/common';
import { dateFormate, dateLocale } from '../utils/PickDateAdapter';

@Component({
  selector: 'online-app-person-details',
  templateUrl: './person-details.component.html',
  styleUrls: ['./person-details.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => PersonDetailsComponent),
    multi: true
  }],
  animations: [slideInOut]
})
export class PersonDetailsComponent implements OnInit, OnChanges, ControlValueAccessor {

  @Input() config: PersonDetailsConfig;
  @Input() errors: PersonDetailsErrors;
  @Input() data: PersonDetails;


  gender = '';
  hasPassport: boolean;
  isRefusedAusVisaBefore: boolean;
  visaRefusalDetails: string;
  selectedNationality: LookupData;
  selectedCountryOfBirth: LookupData;
  selectedRelationship: LookupData;
  

  constructor() {

    this.selectedRelationship = this.getDefaultRelationship();

    // this.configureJQuery();
   }


  disabled = false;
  relationships = [];
  nationalityCountries = [];

  showRelationShipNotification1 = false;
  showRelationShipNotification2 = false;

  private _value: PersonDetails = {
    relationship: undefined,
    otherRelationship: undefined,
    givenName: undefined,
    familyName: undefined,
    preferredName: undefined,
    isRefusedAusVisaBefore: undefined,
    visaRefusalDetails: undefined,
    dateOfBirth: undefined,
    gender: undefined,
    countryOfBirth: undefined,
    nationality: undefined,
    hasPassport: undefined,
    passportNumber: undefined,
    passportExpiryDate: undefined,
    emailAddress: undefined,
    onlyHasOneName: undefined,
  };

  private _onChange = (_: any) => {};
  private _onTouched = (_: any) => {};

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.data && changes.data.currentValue) {
      this.value = changes.data.currentValue;

      const { relationship } = changes.data.currentValue;
      this.relationshipUpdate(relationship);


      const { nationality } = changes.data.currentValue;
      this.nationalityUpdate(nationality);

      const { countryOfBirth } = changes.data.currentValue;
      this.countryOfBirthUpdate(countryOfBirth);

      const { gender } = changes.data.currentValue;
      this.loadGender(gender);
      this.updateIsRefusedAusVisaBefore(this.data.isRefusedAusVisaBefore);

      const { hasPassport } = changes.data.currentValue;
      this.loadHasPassport(hasPassport);
    }


    if (changes.config && changes.config.currentValue) {

      const { nationalityCountries, countries } = changes.config.currentValue;

      if (nationalityCountries && nationalityCountries.length > 0) {

        this.nationalityCountries = nationalityCountries;

      } else {

        this.nationalityCountries = countries;
      }
    }

  }

  updateDateOfBirth(dateInString: any) {
    // const date = this.getDateFromString(formatDate(dateInString, dateFormate, dateLocale));
    // const dateTimeObject = DateTime.fromJSDate(date);

    // if (dateTimeObject.isValid) {
    //   this.setDateOfBirth(date);
    // } else {
    //   this.dateOfBirthUpdateValue('');
    // }
    this.errors.dateOfBirth = '';
  }

  updatePassportExpiryDate(dateInString: any) {
    // const date = this.getDateFromString(formatDate(dateInString, dateFormate, dateLocale));
    // const dateTimeObject = DateTime.fromJSDate(date);

    // if (dateTimeObject.isValid) {
    //   this.setPassportExpiryDate(date);
    // } else {
    //   this.passportExpiryDateUpdateValue('');
    // }
    this.errors.passportExpiryDate = '';
  }

  getDateFromString(dateInString: string): Date {
    const dateParts = dateInString.split('/');
    return new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]);
  }



  getDefaultRelationship(): LookupData {
    return {
      Code: '',
      Description: 'Please select'
    };
  }


  getDateInString(dateObject: Date): string {
    return `${dateObject.getDate()}/${dateObject.getMonth() + 1}/${dateObject.getFullYear()}`;
  }

  setDateOfBirth(dateObject: Date) {
    this.dateOfBirthUpdateValue(this.getDateInString(dateObject));
  }

  setPassportExpiryDate(dateObject: Date) {
    this.passportExpiryDateUpdateValue(this.getDateInString(dateObject));
  }

  set value(value: PersonDetails) {
    this._value = value;
    this._onChange(this._value);
  }

  get value() {
    return this._value;
  }


  writeValue(value: PersonDetails): void {
    if (value && value !== null) {
      this._value = value;
    }
  }
  registerOnChange(fn: (_: any) => void): void {
    this._onChange = fn;
  }
  registerOnTouched(fn: (_: any) => void): void {
    this._onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  relationshipUpdate(code: any) {

    const selectedRelationship = this.config.relationships.find( relation => relation.Code === code);
    this.selectedRelationship = selectedRelationship ?
                                  { Code: selectedRelationship.Code, Description: selectedRelationship.Description }
                                  : this.getDefaultRelationship();

    this._updateValue(code, 'relationship');
    this.errors.relationship = '';


    if (selectedRelationship && selectedRelationship.Description !== 'Please select') {
      if (selectedRelationship.IsDirectRelative) {
        this.showRelationShipNotification1 = true;
        this.showRelationShipNotification2 = false;
      } else {
        this.showRelationShipNotification1 = false;
        this.showRelationShipNotification2 = true;
      }
    } else {
      this.showRelationShipNotification1 = false;
      this.showRelationShipNotification2 = false;
    }

  }

  get isSelectdRelativeParentOrDirectRelative(): boolean {
    if (this.selectedRelationship.Code === 'MTH' || this.selectedRelationship.Code === 'FTH') {
      return true;
    }

    const selectedRelationshipX = this.config.relationships.find(x => x.Code === this.selectedRelationship.Code)
    
    return !!selectedRelationshipX && selectedRelationshipX.IsDirectRelative;
  }

  otherRelationshipUpdate(event: any) {
    this._updateValue(event.target.value, 'otherRelationship');
    this.errors.otherRelationship = '';
  }

  givenNameUpdate(event: any) {
    // additional check or process
    this._updateValue(event.target.value, 'givenName');
    this.errors.givenName = '';
    this.value.givenName = this.titleCaseWord(this.value.givenName);
  }

  familyNameUpdate(event: any) {
    // additional check or process
    this._updateValue(event.target.value, 'familyName');
    this.errors.familyName = '';
    this.value.familyName = this.value.familyName.toUpperCase();
  }

  preferredNameUpdate(event: any) {
    // additional check or process
    this._updateValue(event.target.value, 'preferredName');
    this.errors.preferredName = '';
  }

  updateIsRefusedAusVisaBefore(isRefusedAusVisaBefore: boolean) {

    this.isRefusedAusVisaBefore = isRefusedAusVisaBefore;
    this._updateValue(isRefusedAusVisaBefore, 'isRefusedAusVisaBefore');
    this.errors.isRefusedAusVisaBefore = '';
  }

  visaRefusalDetailsUpdate(event: any) {

    this.visaRefusalDetails = event.target.value;
    this._updateValue(event.target.value, 'visaRefusalDetails');
    this.errors.visaRefusalDetails = '';
  }

  dateOfBirthUpdateValue(value: any) {
    this._updateValue(value, 'dateOfBirth');
    this.errors.dateOfBirth = '';
  }

  passportExpiryDateUpdateValue(value: any) {
    this._updateValue(value, 'passportExpiryDate');
    this.errors.passportExpiryDate = '';
  }

  getDateOfBirthValue(): Date {
    return this.value.dateOfBirth ? this.getDateFromString(this.value.dateOfBirth) : null;
  }
  getPassportExpiryDateValue(): Date {
    return this.value.passportExpiryDate ? this.getDateFromString(this.value.passportExpiryDate) : null;
  }

  updateHasPassport(hasPassport: boolean) {
    if (hasPassport === true) {
      this._updateValue(true, 'hasPassport');
      this.hasPassport = true;
      this.errors.hasPassport = '';
    } else if (hasPassport === false) {
      this._updateValue(false, 'hasPassport');
      this.hasPassport = false;
      this.errors.hasPassport = '';
    } else {
      this._updateValue('', 'hasPassport');
    }

    // this.configureJQuery();
  }

  loadHasPassport(hasPassport: boolean) {
    this.updateHasPassport(hasPassport);
  }


  updateGenderValue(genderValue: string) {

    if (genderValue === 'male') {
      this._updateValue('M', 'gender');
      this.gender = 'M';
      this.errors.gender = '';
    } else if (genderValue === 'female') {
      this._updateValue('F', 'gender');
      this.gender = 'F';
      this.errors.gender = '';
    } else {
      this._updateValue('', 'gender');
      this.gender = '';
    }

  }

  loadGender(gender: string) {
    if (gender === 'M') {
      this.updateGenderValue('male');
    } else if (gender === 'F') {
      this.updateGenderValue('female');
    } else {
      this.updateGenderValue('');
    }
  }

  countryOfBirthUpdate(code: any) {
    // additional check or process
    this._updateValue(code, 'countryOfBirth');
    this.errors.countryOfBirth = '';
  }


  nationalityUpdate(code: any) {
    // additional check or process
    this._updateValue(code, 'nationality');
    this.errors.nationality = '';
  }

  passportNumberUpdate(event: any) {
    // additional check or process
    this._updateValue(event.target.value, 'passportNumber');
    this.errors.passportNumber = '';
  }

  emailAddressUpdate(event: any) {
    // additional check or process
    this._updateValue(event.target.value, 'emailAddress');
    this.errors.emailAddress = '';
  }

  private _updateValue(value: any, field: string) {
    const newValue = this._value;
    newValue[field] = value;
    this.value = newValue;
  }

  titleCaseWord(word: string) {
    if (!word) return word;
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }


  isOnlyHasOneNameClicked(event) {

    if (this.config.isSubmittedApplication) {
      return;
    }
    this.value.onlyHasOneName = event.checked;
    const onlyHasOneNameNewValue = this.value.onlyHasOneName;
    this._updateValue(onlyHasOneNameNewValue, 'onlyHasOneName');

    if (this.value.onlyHasOneName) {
      this.value.familyName = '';
    }
  }


  isBlockedNationality(): boolean {
    return  this.errors && this.errors.nationality && this.errors.nationality.length <= 200;
  }

  isAgentMandatoryNationality(): boolean {
    return  this.errors && this.errors.nationality && this.errors.nationality.length > 200;
  }

  /* For accessibility, keyboard only design, use tab to show borders but showing no border by clicking on mouse */
  keyboardFocus(event): void {
    event.style.outline = "1px solid blue";
  }

  keyboardBlur(event): void {
    event.style.outline = "";
  }

}
